import themes from '@/assets/themes.json';
import type { AutocompleteDestination } from '@/interfaces';

export const getThemeAutocomplete = (value: string): AutocompleteDestination[] => {
    const matchValue = value.trim().toLocaleLowerCase();
    const out: AutocompleteDestination[] = [];

    if ('mine favoritthoteller'.includes(matchValue)) {
        out.push({
            text: 'Mine Favoritthoteller',
            themePath: 'favoritter',
            searchable: true,
            hierarchy: [],
            type: 'theme',
        });
    } else {
        Object.entries(themes).forEach(([key, theme]) => {
            if (key.includes(matchValue) || theme.title.toLocaleLowerCase().includes(matchValue)) {
                out.push({
                    text: theme.title,
                    searchable: true,
                    themePath: `tema/${key}`,
                    hierarchy: [],
                    type: 'theme',
                });
            }
        });
    }

    return out;
};
